const FAQ = [
  {
    question: "What are the signs my foundation may need repair?",
    answer:
      "Common signs of foundation issues<IN_CITY_ZIP> include wall or floor cracks, uneven floors, sticking doors or windows, and separation between walls and ceilings. If you notice these, schedule a professional evaluation as soon as possible.",
  },
  {
    question: "Do you handle both foundation repairs and new construction?",
    answer:
      "Yes. Modern Build provides complete foundation services<IN_CITY_ZIP> — including inspections, structural repairs, replacements, and new foundations for home additions or ground-up construction.",
  },
  {
    question: "How long does a foundation project take?",
    answer:
      "Project timelines vary<IN_CITY_ZIP>. Minor repairs may take 2–5 days, while full replacements or new builds can take several weeks. We provide a detailed timeline after your initial on-site evaluation.",
  },
  {
    question: "Do I need permits for foundation repair or construction?",
    answer:
      "Yes. In almost all cities<IN_CITY_ZIP>, foundation work requires engineering and city permits. Modern Build manages everything from plan drafting to final inspection for full code compliance.",
  },
  {
    question: "Can I live at home during foundation work?",
    answer:
      "In most cases, yes. If the work<IN_CITY_ZIP> is limited to one section or a crawlspace, you can stay home. For full foundation replacement or major structural work, we’ll let you know if temporary relocation is recommended.",
  },
  {
    question: "What types of foundations do you work on?",
    answer:
      "We work on slab foundations, raised foundations, crawlspaces, and footing systems<IN_CITY_ZIP>. Our team is experienced with both modern and older homes<IN_CITY_ZIP>.",
  },
  {
    question: "Do you offer financing for foundation projects?",
    answer:
      "Yes. We offer flexible financing<IN_CITY_ZIP>, including $0 down and affordable monthly plans. Ask us about options during your free consultation — pre-approval is fast and won’t impact your credit.",
  },
  {
    question: "How much does foundation repair cost?",
    answer:
      "Costs vary based on the severity of the issue<IN_CITY_ZIP>, access to the site, and type of foundation. Minor fixes may cost $4,000–$8,000, while major structural repairs or full replacements can range higher. We provide a detailed estimate after inspection.",
  },
  {
    question: "Why choose Modern Build for foundation services?",
    answer:
      "Modern Build connects homeowners in <IN_CITY_ZIP> with licensed, bonded, and insured foundation specialists. Our trusted contractor partners are experienced in both residential and small-scale commercial projects, delivering structural expertise, a transparent process, and a commitment to lasting quality.",
  },
];

export default FAQ;
